import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AccountAlert from '../components/AccountAlerts/accountAlertsMenu';
import {
    getAccountAlertRegistrations,
    getAccountAlertTypes,
    bankingAlerts,
    accountAlerts,
    removeAlertRegistration,
    addAlertRegistration,
    updateAlertCriteria,
    removeAllAccountRegistrations
} from "../actions/actions";
import _ from "lodash";


const mapStateToProps = (state, ownProps) => ({
    bankingAlertsState: state.bankingAlertsReducer.bankingAlertsState,
    accountAlertState: state.accountAlertsReducer.accountAlertState,
    accountAlertPreferencesReducer:
        state.accountAlertPreferencesReducer[ownProps.match.params.accountno],
    accountAlertTypes: state.accountAlertTypesReducer[ownProps.match.params.accountno],
    deliveryAddresses: _.get(
        state.accountAlertsReducer,
        "items.deliveryMethods",
        []
    )
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            getAccountAlertRegistrations,
            getAccountAlertTypes,
            bankingAlerts,
            accountAlerts,
            removeAlertRegistration,
            addAlertRegistration,
            updateAlertCriteria,
            removeAllAccountRegistrations
        },
        dispatch
    );
};
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(AccountAlert);
